import type { ParentProgress } from "../types";

export interface ParentCardProps {
  progress: ParentProgress;
  /** Sprint-003 A6: set only for a `can_hand_out_work` viewer — tapping
   * opens the parent-detail overlay (piece list + "Mark the whole thing
   * done"), resolving design-spec-today-card.md §6 guess #4 ("production
   * should route it into the same sub-task detail pattern"). Omitted
   * entirely (plain, non-interactive card) for a helper, matching the
   * mock's read-only Team person-detail treatment. */
  onOpen?: () => void;
}

export function ParentCard({ progress, onOpen }: ParentCardProps) {
  const pct = progress.total > 0 ? Math.round((progress.done / progress.total) * 100) : 0;
  const badge = (
    // Sprint-006 D3 — "N of M done" changes live as pieces are tapped
    // (design-spec-today-card.md §3.4's "computed from children live");
    // announce that change to screen-reader users the same way the
    // offline banner/snackbar already do.
    <span class="parent-badge" role="status" aria-live="polite">
      {progress.done} of {progress.total} done
    </span>
  );
  const body = (
    <>
      <div class="parent-card-top">
        <div>
          <div class="parent-title">{progress.title}</div>
          <div class="parent-sub">{onOpen ? "Tap to see who's doing what" : "Handed out"}</div>
        </div>
        {badge}
      </div>
      <div class="parent-progress-track">
        <div class="parent-progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </>
  );

  if (!onOpen) {
    return (
      <div class="parent-card" data-parent-id={progress.parent_assignment_id}>
        {body}
      </div>
    );
  }

  return (
    <button
      type="button"
      class="parent-card"
      data-parent-id={progress.parent_assignment_id}
      onClick={onOpen}
    >
      {body}
    </button>
  );
}
